export enum ChatType {
    General = 0,
    AllCvs = 1,
}
